import template from './divider.html';
import './divider.less';

let dividerComponent = {
    template
};

export default dividerComponent;
